import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { FullPatientFragment } from 'src/participant/patientQueries.generated'
import { useFeatureFlag } from 'src/featureFlags'
import { COLLAPSED_SIDEBAR_CONTROL_WIDTH, useSidebarControls } from 'src/designSystem/Container/sidebarControls'
import { useGetParticipantVideoCallBookingInformation } from './useGetParticipantVideoCallBookingInformation'
import InProgramVideoCallBookingContainer from './InProgramVideoCallBookingContainer'
import IntakeVideoCallBookingContainer from './IntakeVideoCallBookingContainer'
import ScheduleIntakeCall from './IntakeBookingWithoutBookingDataContainer/ScheduleIntakeCall'

type Props = {
  uid: string
  participantWithFullInformation?: FullPatientFragment
}

const VideoCallBookingHeader = ({ uid, participantWithFullInformation }: Props) => {
  const hasPriorityFilters = useFeatureFlag('featureFlagDashboardPriorityFilters')
  const { isCollapsed } = useSidebarControls()
  const styles = useStyles({ isSidebarCollapsed: hasPriorityFilters && isCollapsed })

  const { data } = useGetParticipantVideoCallBookingInformation(uid)

  if (!data?.patient || !participantWithFullInformation) {
    return null
  }

  const { patient: participantWithBookingInformation } = data
  const { videoCallBookingInformation: bookingInformation } = participantWithBookingInformation

  if (!bookingInformation) {
    return (
      <div className={styles.container}>
        <ScheduleIntakeCall
          participantWithBookingInformation={participantWithBookingInformation}
          participantWithFullInformation={participantWithFullInformation}
        />
      </div>
    )
  }

  const bookingInformationType = bookingInformation.__typename

  if (bookingInformationType === 'InProgramVideoCallBookingInformation') {
    return (
      <div className={styles.container}>
        <InProgramVideoCallBookingContainer
          bookingInformation={bookingInformation}
          participantWithBookingInformation={participantWithBookingInformation}
        />
      </div>
    )
  }

  if (bookingInformationType === 'IntakeVideoCallBookingInformation') {
    return (
      <div className={styles.container}>
        <IntakeVideoCallBookingContainer
          bookingInformation={bookingInformation}
          participantWithBookingInformation={participantWithBookingInformation}
        />
      </div>
    )
  }

  return null
}

const useStyles = makeStyles((theme) => ({
  container: ({ isSidebarCollapsed }: { isSidebarCollapsed: boolean }) => ({
    padding: theme.spacing(2),
    paddingLeft: isSidebarCollapsed ? COLLAPSED_SIDEBAR_CONTROL_WIDTH : theme.spacing(2),
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'white',
    maxHeight: '360px',
    overflowY: 'auto',
  }),
}))

export default VideoCallBookingHeader
